import { useEffect, useState } from "react";
import { toast } from "sonner";
import { api, errMsg } from "@/lib/api";

const STATUS = [["new", "New"], ["reviewing", "Reviewing"], ["done", "Done"], ["wont_fix", "Won't fix"]];
const KIND = { problem: "Problem", idea: "Idea", other: "Other" };

export const FeedbackAdmin = () => {
  const [list, setList] = useState(null);
  const [filter, setFilter] = useState("open");
  const load = () => api.get("/admin/feedback").then(({ data }) => setList(data));
  useEffect(() => {
    load();
  }, []);
  const setStatus = async (id, status) => { try { await api.put(`/admin/feedback/${id}`, { status }); load(); } catch (e) { toast.error(errMsg(e)); } };
  if (!list) return <p className="text-sm text-slate-500">Loading…</p>;
  const shown = list.filter((f) => filter === "all" || (filter === "open" ? ["new", "reviewing"].includes(f.status) : f.kind === filter));
  return (
    <section className="card p-5" data-testid="admin-feedback">
      <div className="mb-3 flex flex-wrap items-center justify-between gap-2"><h3 className="font-semibold text-[#0B192C]">Tester feedback ({list.filter((f) => f.status === "new").length} new)</h3>
        <select aria-label="Filter feedback" className="input !w-44 py-1.5 text-sm" value={filter} onChange={(e) => setFilter(e.target.value)} data-testid="feedback-filter"><option value="open">Open</option><option value="problem">Problems</option><option value="idea">Ideas</option><option value="all">All</option></select></div>
      {shown.length === 0 ? <p className="text-sm text-slate-500" data-testid="feedback-empty">Nothing here.</p> : (
        <ul>{shown.map((f) => (
          <li key={f.id} className="border-t border-slate-100 py-3 first:border-0" data-testid={`feedback-${f.id}`}>
            <div className="flex flex-wrap items-center justify-between gap-2">
              <p className="text-xs text-slate-500"><span className={`mr-2 rounded-full px-2 py-0.5 font-semibold ${f.kind === "problem" ? "bg-red-50 text-red-700" : f.kind === "idea" ? "bg-teal-50 text-teal-800" : "bg-slate-100 text-slate-600"}`}>{KIND[f.kind]}</span>{new Date(f.at).toLocaleString("en-GB")} · {f.page || "?"} · {f.email || "anonymous"} · {f.viewport}</p>
              <select aria-label="Status" className="input !w-32 py-1 text-xs" value={f.status} onChange={(e) => setStatus(f.id, e.target.value)} data-testid={`feedback-status-${f.id}`}>{STATUS.map(([k, l]) => <option key={k} value={k}>{l}</option>)}</select>
            </div>
            <p className="mt-1 whitespace-pre-wrap text-sm text-slate-800">{f.message}</p>
          </li>))}</ul>)}
    </section>
  );
};
